import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Политика конфиденциальности
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" gutterBottom>
          Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
        </Typography>
        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            1. Введение
          </Typography>
          <Typography variant="body1" paragraph>
            Добро пожаловать на сайт DomikTyumen. Мы уважаем вашу конфиденциальность и стремимся защищать ваши персональные данные. Эта политика конфиденциальности объясняет, как мы собираем, используем и защищаем информацию, которую вы предоставляете нам при использовании нашего сервиса.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            2. Какую информацию мы собираем
          </Typography>
          <Typography variant="body1" paragraph>
            При регистрации на нашем сайте мы собираем следующую информацию:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Имя</li>
            <li>Номер телефона</li>
            <li>Адрес электронной почты (email)</li>
          </Typography>
          <Typography variant="body1" paragraph sx={{ mt: 2 }}>
            Мы также можем собирать информацию о вашем использовании нашего сайта, включая IP-адрес, тип браузера, время посещения и просмотренные страницы.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            3. Как мы используем вашу информацию
          </Typography>
          <Typography variant="body1" paragraph>
            Мы используем собранную информацию исключительно для следующих целей:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Обеспечение функционирования сервиса онлайн-бронирования</li>
            <li>Обработка и подтверждение ваших бронирований</li>
            <li>Связь с вами по вопросам, связанным с вашими бронированиями</li>
            <li>Информирование о специальных предложениях и рекламных акциях (с вашего согласия)</li>
            <li>Улучшение нашего сервиса и пользовательского опыта</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            4. Защита данных
          </Typography>
          <Typography variant="body1" paragraph>
            Мы принимаем соответствующие меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения. Мы используем различные технологии безопасности и процедуры для защиты ваших персональных данных от несанкционированного доступа.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            5. Раскрытие информации третьим лицам
          </Typography>
          <Typography variant="body1" paragraph>
            Мы не продаем, не обмениваем и не передаем ваши персональные данные третьим лицам без вашего согласия, за исключением случаев, когда это необходимо для предоставления запрошенных вами услуг или когда это требуется по закону.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            6. Маркетинговые коммуникации
          </Typography>
          <Typography variant="body1" paragraph>
            Мы можем использовать ваш email и номер телефона для отправки информации о наших услугах, специальных предложениях и рекламных акциях. Вы можете в любое время отказаться от получения маркетинговых сообщений, связавшись с нами или используя функцию отписки в наших электронных письмах.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            7. Файлы cookie
          </Typography>
          <Typography variant="body1" paragraph>
            Наш сайт использует файлы cookie для улучшения пользовательского опыта. Вы можете настроить свой браузер так, чтобы отклонять файлы cookie или уведомлять вас, когда они отправляются. Однако это может ограничить функциональность нашего сайта.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            8. Ваши права
          </Typography>
          <Typography variant="body1" paragraph>
            Вы имеете право запросить доступ к своим персональным данным, их исправление или удаление. Вы также можете возражать против обработки ваших данных или запрашивать ограничение такой обработки. Для осуществления этих прав, пожалуйста, свяжитесь с нами.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            9. Правовые основания обработки персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Обработка персональных данных осуществляется в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — ФЗ-152). Мы осуществляем обработку персональных данных на следующих правовых основаниях:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>Согласие субъекта персональных данных</strong> (п. 1 ч. 1 ст. 6 ФЗ-152) — индивидуального предпринимателя, арендатора, гостя</li>
            <li><strong>Заключение и исполнение договора</strong> (п. 5 ч. 1 ст. 6 ФЗ-152) — договора аренды, бронирования</li>
            <li><strong>Исполнение обязательств по закону</strong> (п. 2 ч. 1 ст. 6 ФЗ-152) — налоговое, бухгалтерское законодательство</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            10. Категории субъектов персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Мы обрабатываем персональные данные следующих категорий субъектов:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>Арендаторы и гости</strong> — физические лица, заключающие договоры аренды или бронирования</li>
            <li><strong>Пользователи сайта</strong> — посетители сайта domik72.ru</li>
            <li><strong>Подписчики рассылки</strong> — лица, подписавшиеся на email-рассылку</li>
            <li><strong>Представители контрагентов</strong> — контактные лица организаций-партнёров</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            11. Порядок и условия обработки персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Сбор:</strong> Персональные данные собираются при регистрации на сайте, оформлении бронирования, подписке на рассылку, оставлении отзывов и комментариев.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Использование:</strong> Персональные данные используются исключительно для целей, указанных в п. 3 настоящей Политики.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Хранение:</strong> Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, или до момента отзыва согласия субъектом.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Защита:</strong> Мы применяем организационные и технические меры защиты персональных данных в соответствии с требованиями ст. 19 ФЗ-152.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            12. Сроки хранения персональных данных
          </Typography>
          <Typography variant="body1" paragraph>
            Персональные данные хранятся в следующие сроки:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li><strong>Данные бухгалтерского учёта</strong> — 5 лет (ФЗ-402 «О бухгалтерском учёте»)</li>
            <li><strong>Договоры аренды</strong> — 5 лет после окончания срока действия</li>
            <li><strong>Данные бронирований</strong> — 3 года (срок исковой давности)</li>
            <li><strong>Email-подписка</strong> — до отписки</li>
            <li><strong>Комментарии и отзывы</strong> — до удаления пользователем или ликвидации аккаунта</li>
            <li><strong>Данные учётной записи</strong> — до удаления аккаунта по запросу</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            13. Изменения в политике конфиденциальности
          </Typography>
          <Typography variant="body1" paragraph>
            Мы можем обновлять нашу политику конфиденциальности время от времени. Мы будем уведомлять вас о любых изменениях, публикуя новую политику конфиденциальности на этой странице. Рекомендуем периодически проверять эту страницу на наличие изменений.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>
            14. Контактная информация
          </Typography>
          <Typography variant="body1" paragraph>
            Если у вас есть вопросы или предложения относительно нашей политики конфиденциальности, пожалуйста, свяжитесь с нами:
          </Typography>
          <Typography variant="body1">
            Email: admin@domik72.ru
          </Typography>
          <Typography variant="body1">
            Телефон: +7 (963) 060-02-55
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
